import emojiRegex from 'emoji-regex';

export const removeEmojies = (string: string) =>
  string.replace(emojiRegex(), '');
